import RadioInput from '../RadioInput/RadioInput';
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import BtnSubmit from '../Buttons/BtnSubmit';
import { setServiceForm, setServiceFormKeysOnLoad } from './ServiceAccessFormSlice';
import { serviceData } from './ServiceAccessFormDefaultData';

const ServiceAccessForm = (props) => {
  const servicesContent = props.serviceData ? props.serviceData : serviceData; //default services
  const defaultOpenServices = props.defaultOpenServices || [];

  const getStoreServices = () => {
    let servicesArr = [];
    if (props.services.serviceFormIsSign) {
      for (let key in props.services.serviceForm) {
        if (props.services.serviceForm[key]) {
          servicesArr.push(key);
        }
      }
    }
    return servicesArr;
  };

  const [openServices, setOpenServices] = useState(getStoreServices());

  useEffect(() => {
    if (Object.keys(props.services.serviceForm).length === 0) {
      props.setServiceFormKeysOnLoad(servicesContent);
    }
  }, []);

  useEffect(() => {
    if (props.services.serviceFormLoaded && defaultOpenServices.length > 0) {
      defaultOpenServices.map((serviceType) => {
        setOpenServices([...openServices, serviceType]);
      })
    }
  }, [props.services.serviceFormLoaded]);

  const submitServices = () => {
    props.setServiceForm(openServices);
    if (props.setShowPopUp) {
      props.setShowPopUp(false);
    }
  };

  const RadioBtnService = ({ service }) => {
    return (
      <div className='radio-btn'>
        <RadioInput
          id={'close' + service.type}
          name={'ServiceForm' + service.type}
          checked={!openServices.includes(service.type)}
          onChange={() => {
            setOpenServices(openServices.filter((s) => s !== service.type));
          }}
        />
        <RadioInput
          id={'open' + service.type}
          name={'ServiceForm' + service.type}
          checked={openServices.includes(service.type)}
          onChange={() => {
            setOpenServices([...openServices, service.type]);
          }}
        />
      </div>
    );
  };

  return (
    <div className='servicesForm'>
      <div className='L_Title extra'> טופס גישה לשירותים </div>

      <div className='wrap-section'>
        {servicesContent.map((item, SectionId) => {
          return (
            <div className='section' key={SectionId}>
              {SectionId == 0 && (
                <div className='openCloseTitle'>
                  <div>
                    <span>חסום</span>
                    <span>פתוח</span>
                  </div>
                </div>
              )}
              <div className='section-title'>
                {item.title && (
                  <div className={`mainTitle ${!item.services[0].value ? 'withoutServiceText' : ''}`}>
                    {SectionId + 1}. <div className="mainTitle-text" dangerouslySetInnerHTML={{ __html: item.title }} />
                    {!item.services[0].value &&
                      <RadioBtnService service={item.services[0]} />
                    }
                  </div>
                )}
              </div>

              {item.services[0].value &&
                <ol>
                  {item.services.map((service, ServiceId) => {
                    return (
                      <>
                        {!service.type ?
                          <div className='service-text'>{service.value}</div> :
                          <li className='service hebrew_li' key={ServiceId}>
                            <div className='service-text'>{service.value}</div>
                            <div className='radio-btn'>
                              <RadioBtnService service={service} />
                            </div>
                          </li>
                        }
                      </>
                    );
                  })}
                </ol>
              }
            </div>
          );
        })}
      </div>
      <BtnSubmit text={'אישור וחזרה לתהליך'} onclick={() => submitServices()} />
    </div>
  );
};

const mapStateToProps = (state) => ({
  services: state.serviceAccessForm,
});

const mapDispatchToProps = {
  setServiceForm,
  setServiceFormKeysOnLoad,
};

export default connect(mapStateToProps, mapDispatchToProps)(ServiceAccessForm);
